import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
    ApiError,
    AITextAgentListParams,
    AITextAgentListResponse,
} from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<AITextAgentListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchTextAgentList = async (
    params: AITextAgentListParams
): Promise<AITextAgentListResponse> => {
    const url = apiEndpoints.aiTextAgents.getList(params);
    const response = await api.get(url);
    return response?.data?.data;
};

const useTextAgents = (params: AITextAgentListParams, options?: QueryOptions) => {
    return useQuery<AITextAgentListResponse, ApiError>({
        queryKey: ['ai-text-agent', 'list', params],
        queryFn: () => fetchTextAgentList(params),
        ...options,
    });
};

export default useTextAgents;
